export default __webpack_public_path__ + "static/media/Small Napalm Cocktail.1fa31473.PNG";